interface IProps {
  width?: number
  height?: number
}

const Icatu = ({ width, height }: IProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      version='1.1'
      viewBox='0 0 700 700'
    >
      <g transform='matrix(.87524 0 0 .87524 72.338 251.041)'>
        <path
          fill='#002855'
          fillOpacity='1'
          fillRule='evenodd'
          d='M204.93 223.83c2.66-7.54 5.19-14.81 7.79-22.06 15.54-43.18 31.12-86.35 46.59-129.56.81-2.25 1.8-2.94 4.16-2.92 13.88.12 27.76.11 41.64.01 2.18-.02 3.21.59 3.99 2.69 14.51 39.14 29.11 78.25 43.68 117.37 3.94 10.59 7.83 21.2 11.87 31.75.81 2.13.65 2.77-1.82 2.76-16.66-.08-33.32-.07-49.97-.01-1.78.01-2.6-.54-3.22-2.27-3.3-9.11-6.82-18.13-10.13-27.24-.76-2.09-1.63-3.03-4.1-3.01-16.31.14-32.62.11-48.93.05-1.99-.01-2.99.44-3.7 2.55-3.02 8.96-6.38 17.8-9.49 26.73-.78 2.23-1.74 3.3-4.37 3.23-7.86-.21-15.72-.07-23.99-.07zm65.54-106.84c-1.7 4.73-3.1 8.63-4.5 12.52-4.04 11.27-8.09 22.55-12.11 33.83-.37 1.04-1.57 2.53.96 2.53h33.96c-6.12-16.34-12.09-32.28-18.31-48.88z'
          className='st0'
        ></path>
        <path
          fill='#002855'
          fillOpacity='1'
          fillRule='evenodd'
          d='M549.85 122.22c0 15.61-.03 31.23.01 46.84.01 5.23.98 10.32 2.57 15.31 2.86 8.97 8.85 14.39 18.13 16.07 7.04 1.28 14.08 1.21 20.93-.91 8.53-2.63 13.14-8.95 15.34-17.3 1.57-5.97 2.09-12.06 2.1-18.19.03-30.19.08-60.37-.05-90.56-.01-3.3.72-4.36 4.14-4.19 6.23.31 12.49.16 18.73.05 2.05-.04 2.8.46 2.79 2.68-.08 32.62.17 65.23-.18 97.84-.12 11.59-2.31 22.99-8.52 33.18-6.97 11.43-17.73 17.44-30.33 20.06-20.28 4.23-40.61 4.2-60.78-1.16-20.09-5.34-33.7-21.19-36.31-41.78-.98-7.72-1.28-15.42-1.27-23.16.03-27.87.05-55.75-.05-83.62-.01-2.97.5-4.15 3.88-4.1 15.15.21 30.31.16 45.46.03 2.66-.02 3.29.76 3.27 3.31-.11 16.54-.05 33.08-.05 49.62.06-.02.12-.02.19-.02z'
          className='st0'
        ></path>
        <path
          fill='#002855'
          fillOpacity='1'
          fillRule='evenodd'
          d='M156.66 225.32c-15.43-.19-30.9-1.47-45.61-7.52-20.56-8.45-32.65-23.95-37.32-45.36-4.39-20.11-4.12-40.18 2.42-59.84 7.35-22.08 23.37-34.84 45.39-40.58 21.05-5.49 42.34-4.78 63.66-1.79 3.54.5 7.05 1.21 10.6 1.66 1.68.21 2.05.96 1.9 2.82-.42 5.19-.37 10.41.02 15.6.25 3.38-1.73 2.56-3.25 2.33-8.59-1.31-17.24-1.86-25.91-1.9-21.95-.11-35.32 9.4-41.32 30.58-5.32 18.78-5.01 37.73 2.01 56.14 6.17 16.18 19.32 24.85 36.66 25.08 9.85.13 19.64-.58 29.37-1.98 2.27-.33 2.49.52 2.46 2.36-.09 4.97-.21 9.95.04 14.91.14 2.68-.91 3.66-3.32 3.98-3.09.4-6.15 1.02-9.23 1.44-9.39 1.3-18.85 1.83-28.57 2.07z'
          className='st0'
        ></path>
        <path
          fill='#002855'
          fillOpacity='1'
          fillRule='evenodd'
          d='M416.43 69.36c21.51 0 43.01.05 64.52-.06 3.17-.02 4.03.75 3.58 4.85-.58 5.31-.6 10.69.02 16 .52 4.41-.72 5-3.98 4.96-11.68-.15-23.36.05-35.03-.13-2.98-.05-3.59.91-3.59 3.71.09 40.35.02 80.69.13 121.04.01 3.29-.7 4.25-4.12 4.2-14.45-.21-28.91-.18-43.36-.02-2.98.03-3.86-.61-3.85-3.75.12-40.35.04-80.69.17-121.04.01-3.38-.86-4.22-4.19-4.16-12.92.24-25.84-.04-38.76.2.32-7.45.36-14.94.12-22.4-.09-2.76.74-3.48 3.47-3.46 21.63.11 43.25.06 64.87.06z'
          className='st0'
        ></path>
        <path
          fill='#002855'
          fillOpacity='1'
          fillRule='evenodd'
          d='M0 146.43c0-24.52.05-49.04-.07-73.55-.01-2.91.81-3.61 3.66-3.58 14.8.15 29.61.13 44.42.02 2.52-.02 3.36.52 3.35 3.22-.08 49.38-.08 98.76 0 148.15 0 2.69-.83 3.24-3.35 3.22-14.8-.12-29.61-.13-44.42.01-2.84.03-3.68-.65-3.66-3.58.12-24.65.07-49.28.07-73.91z'
          className='st0'
        ></path>
        <path
          fill='#5eb948'
          fillOpacity='1'
          fillRule='evenodd'
          d='M416.18 58.82c-16.07 0-29.27-13.23-29.3-29.36C386.85 13.19 400.1-.01 416.44 0c16.07.01 29.23 13.21 29.27 29.37.04 16.31-13.13 29.45-29.53 29.45z'
          className='st1'
        ></path>
      </g>
    </svg>
  )
}

export default Icatu
